<app-expandable-section-box
  [title]="'Columnist Content'"
  [iconClass]="'icon-folder'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1" expandedContent>
    <div class="p-2">
      <mat-checkbox color="primary" [formControl]="isColumnistContent">
        Add to Columnist Content
      </mat-checkbox>
    </div>
  </div>
  <div
    class="flex flex-col gap-y-[0.3rem] p-4 flex-1"
    *ngIf="isColumnistContent.value"
    notExpandedContent
  >
    <ng-container>
      <p class="py-px text-xs text-project-2400">Added to Columnist Content</p>
    </ng-container>
  </div>
</app-expandable-section-box>
